import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCoreStorageList } from "./actions";

export const storageEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = storageEntityAdapter.getInitialState({
  count: 0,
});

export const storageSlice = createSlice({
  name: "coreStorage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoreStorageList.fulfilled, (state, action) => {
      if (action.payload?.statusCode === 200) {
        storageEntityAdapter.setAll(state, action.payload?.data?.data || []);
        state.count = action.payload?.data?.meta?.totalCount || 0;
      }
    });
  },
});
export default storageSlice.reducer;
